export default class BulkAction {
	constructor() {
		this.init();
	}

	init() {
		document.querySelectorAll('select[data-provide="select"][data-datatables-id]:not([data-datatable-init="1"])').forEach(function (select, key) {
			select.setAttribute('data-datatable-init', "1");

			let gridTable = document.getElementById(select.getAttribute('data-datatables-id'));
			let prefix = select.getAttribute('data-handler-prefix');

			if (!gridTable) {
				return;
			}

			$(select).on('select2:select', (e) => {
				let ids = [];
				let link = e.params.data.id;

				if (!link) {
					return;
				}

				gridTable.querySelectorAll('input[type="checkbox"][data-provide="bulkActions"]:checked').forEach(function (checkbox, key) {
					ids.push(checkbox.getAttribute('value'))
				});

				$(select).val(null).trigger('change');
				window.naja.makeRequest("POST", link, {[`${prefix}ids`]: JSON.stringify(ids)}, {history: false}).then(r => {});
			});
		});

	}
}
